export default __webpack_public_path__ + "static/media/fx.20658297.svg";